"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _typeof2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/typeof.js"));
var _toConsumableArray2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.array.join.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.every.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.json.parse.js");
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/es.string.split.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _auth = require("@/utils/auth");
var _mixins = _interopRequireDefault(require("./mixins"));
var _file = _interopRequireDefault(require("./components/file.vue"));
var _fileFullImage = _interopRequireDefault(require("./components/file-full-image.vue"));
var _default = exports.default = {
  name: 'wl-upload',
  /* 混入 */
  mixins: _mixins.default,
  components: {
    fileView: _file.default,
    fileFullImage: _fileFullImage.default
  },
  props: {
    /* v-model */
    value: {
      type: [String, Array],
      default: ''
    },
    /* 是否是列表 */
    isList: {
      type: Boolean,
      default: false
    },
    /* 输出结果 join 拼接 */
    toJoin: {
      type: Boolean,
      default: false
    },
    /* 输出结果 转换成 json 字符串 */
    toJSON: {
      type: Boolean,
      default: true
    },
    /* 宽度 */
    width: {
      type: [Number, String],
      default: '148'
    },
    /* 高度 */
    height: {
      type: [Number, String],
      default: '148'
    }
  },
  data: function data() {
    return {
      selfAdd: false,
      // files        : [], // 文件列表
      defaultFiles: [],
      // 初始文件列表
      /* 默认参数 */
      defaultOptons: {
        limit: 20,
        // drag    : true,
        multiple: this.isList,
        // 'list-type'     : 'text',
        // 'show-file-list': this.isList
        data: {},
        fit: 'contain',
        // max     : true,
        full: true,
        // width   : 200,
        // height  : 200,
        headers: {
          Authorization: 'Bearer ' + (0, _auth.getToken)()
        },
        action: require('@/settings.js').uploadUrl
      },
      // 请求状态，防止同时上传
      uploadRequestStatus: true,
      watchFileId: null,
      fullImage: false,
      defaultImage: {},
      uploadValue: '',
      // 上传文件旧状态
      uploadFilesOld: []
    };
  },
  computed: {
    getJoin: function getJoin() {
      var _this$toJoin;
      if (this.toJoin === false) return false;
      return (_this$toJoin = this.toJoin) !== null && _this$toJoin !== void 0 ? _this$toJoin : ',';
    },
    getOptions: function getOptions() {
      var _Object$keys,
        _this = this;
      (_Object$keys = Object.keys(this.$attrs)) === null || _Object$keys === void 0 || _Object$keys.forEach(function (k) {
        return _this.$attrs[k] === '' && (_this.$attrs[k] = true);
      });
      return this.$$deepMerge(this.defaultOptons, this.$attrs, {
        width: this.width,
        height: this.height
      });
    },
    files: function files() {
      var _this$$refs$wlUpload;
      // eslint-disable-next-line no-unused-expressions
      this.uploadValue;
      return (_this$$refs$wlUpload = this.$refs['wl-upload']) === null || _this$$refs$wlUpload === void 0 ? void 0 : _this$$refs$wlUpload.uploadFiles;
    },
    getLastFile: function getLastFile() {
      var _pop;
      return (_pop = (0, _toConsumableArray2.default)(this.$$isNoEmpty(this.files, 'array') || []).pop()) !== null && _pop !== void 0 ? _pop : {};
    },
    getImageSize: function getImageSize() {
      var _this$$$deepMerge = this.$$deepMerge(this.defaultOptons, this.$attrs, {
          width: this.width,
          height: this.height
        }),
        width = _this$$$deepMerge.width,
        height = _this$$$deepMerge.height;

      // console.log('1', { width, height, 'max-width': '100%' })

      if (!/(em|rem|px|rpx|vw|vh|%)/.test(width)) width += 'px';
      if (!/(em|rem|px|rpx|vw|vh|%)/.test(height)) height += 'px';
      this.renderSize();
      return {
        width: width,
        height: height,
        'max-width': '100%'
      };
    }
  },
  watch: {
    value: {
      handler: function handler() {
        this.handleValue();
        this.renderSize();
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    /** 处理 v-model 数据
     * @return { void }
     */
    handleValue: function handleValue() {
      var _this2 = this;
      var v = this.value;
      var files = [];
      var ref = this.$refs['wl-upload'];
      var a = function a() {
        ref = _this2.$refs['wl-upload'];
        if (_this2.$$isNoEmpty(v)) {
          if (_this2.toJSON && _this2.$$isJSON(v)) files = JSON.parse(v);else if (_this2.toJoin !== false) files = v.split(typeof _this2.getJoin === 'string' ? _this2.getJoin : ',');else if (Array.isArray(v)) files = v;else if (_this2.$$isUrl(v)) files = v.split(',');
        }
        if (_this2.$$isNoEmpty(files)) {
          var _files;
          var repetition = {};
          (_files = files
          /* 重复过滤 */) === null || _files === void 0 || (_files = _files.filter(function (file) {
            var _ref, _file$uid, _ref2;
            var id = (_ref = (_file$uid = file.uid) !== null && _file$uid !== void 0 ? _file$uid : file.id) !== null && _ref !== void 0 ? _ref : file.url;
            var f = (_ref2 = ref) === null || _ref2 === void 0 || (_ref2 = _ref2.uploadFiles) === null || _ref2 === void 0 ? void 0 : _ref2.find(function (f1) {
              return f1.url === file.url;
            });
            if (repetition[id] || !!f) return false;else return (repetition[id] = {}) || true;
          })
          /* 数据处理 */) === null || _files === void 0 || (_files = _files.map(function (file) {
            if ((0, _typeof2.default)(file) === 'object') return file;else if (_this2.$$isUrl(file)) return {
              url: file,
              name: _this2.$$getFileName(file, 1)
            };
            return null;
          })
          /* 空值过滤 */) === null || _files === void 0 || (_files = _files.filter(function (file) {
            return file;
          })
          /* 数据添加 */) === null || _files === void 0 || _files.forEach(function (f1) {
            var _ref3, _f1$uid, _f1$id, _ref4;
            var f2 = (_ref3 = ref) === null || _ref3 === void 0 || (_ref3 = _ref3.uploadFiles) === null || _ref3 === void 0 ? void 0 : _ref3.find(function (f3) {
              return f3.uid === f1.id || f3.uid === f1.uid || f3.url === f1.url;
            });
            (_f1$uid = f1.uid) !== null && _f1$uid !== void 0 ? _f1$uid : f1.uid = (_f1$id = f1.id) !== null && _f1$id !== void 0 ? _f1$id : _this2.$$getMD5(f1.url);
            if (f2) Object.assign(f2, f1);else (_ref4 = ref) === null || _ref4 === void 0 || (_ref4 = _ref4.uploadFiles) === null || _ref4 === void 0 || _ref4.push(f1);
          });
        } else {
          var _ref6;
          _this2.uploadValue = '';
          var fun = function fun() {
            var _ref5;
            return Array.isArray((_ref5 = ref) === null || _ref5 === void 0 ? void 0 : _ref5.uploadFiles) && (ref.uploadFiles.length = 0);
          };
          if ((_ref6 = ref) !== null && _ref6 !== void 0 && _ref6.uploadFiles) fun();else _this2.$nextTick(fun);
        }
        _this2.renderSize();
      };
      if (ref) a();else this.$nextTick(a);
    },
    fullImageFile: function fullImageFile(file) {
      this.fullImage = true;
      this.defaultImage = file;
    },
    renderSize: function renderSize() {
      var _this3 = this;
      this.$nextTick(function () {
        var _this3$$refs$wlUploa;
        var el = (_this3$$refs$wlUploa = _this3.$refs['wl-upload']) === null || _this3$$refs$wlUploa === void 0 ? void 0 : _this3$$refs$wlUploa.$el;
        if (!el) return;
        var _this3$getImageSize = _this3.getImageSize,
          width = _this3$getImageSize.width,
          height = _this3$getImageSize.height;
        var style = ";width: ".concat(width, ";height: ").concat(height, ";'max-width': '100%';");
        var a = el === null || el === void 0 ? void 0 : el.querySelector('.el-upload--picture-card');
        var b = a === null || a === void 0 ? void 0 : a.querySelector('.el-upload-dragger');
        var c = el === null || el === void 0 ? void 0 : el.querySelector('.el-upload-list--picture-card');
        var ds = c === null || c === void 0 ? void 0 : c.querySelectorAll('.el-upload-list__item');
        if (a) a.style.cssText += style;
        if (b) b.style.cssText += style;
        if (c) c.style.cssText += style;
        if (ds) ds.forEach(function (d) {
          return d && (d.style.cssText += style);
        });
      });
    },
    clearFiles: function clearFiles() {
      this.$refs['wl-upload'].clearFiles();
    },
    submit: function submit() {
      this.$refs['wl-upload'].submit();
    }
  },
  mounted: function mounted() {
    var _this4 = this;
    /* 监听上传组件的列表 */
    if (this.$refs['wl-upload']) {
      if (typeof this.watchFileId === 'function') this.watchFileId() && (this.watchFileId = null);
      this.watchFileId = this.$watch(function () {
        return _this4.$refs['wl-upload'].uploadFiles;
      }, function (newValue) {
        var _nValues;
        if (!_this4.isList && _this4.$$isNoEmpty(newValue) && newValue.length > 1) newValue = [(0, _toConsumableArray2.default)(newValue).pop()];
        var oldValue = _this4.uploadFilesOld;
        /* 过滤主要字段 */
        var filter = function filter(v) {
          var _v$response, _v$response2;
          var rv = {
            id: v.uid,
            uid: v.uid,
            url: v.url,
            name: v.name
          };
          var reg = /^(http)(s{0,1})/;
          if (reg.test(v === null || v === void 0 ? void 0 : v.url)) rv.url = v.url;else if (reg.test((_v$response = v.response) === null || _v$response === void 0 ? void 0 : _v$response.url)) rv.url = v.response.url;else if (reg.test((_v$response2 = v.response) === null || _v$response2 === void 0 || (_v$response2 = _v$response2.data) === null || _v$response2 === void 0 ? void 0 : _v$response2.url)) rv.url = v.response.data.url;
          return rv;
        };
        var _ref7 = [newValue.map(filter), oldValue.map(filter)],
          nv = _ref7[0],
          ov = _ref7[1];
        var nValues = nv,
          oValues = ov;

        /* 处理输出数据 */
        /* 需要转换成 JSON 字符串 */
        if (_this4.toJSON) {
          nValues = JSON.stringify(nv);
          oValues = JSON.stringify(ov);
        } /* 需要 将 url 抽出来并做成 join 拼接字符串 */else if (_this4.toJoin !== false) {
          var s = _this4.getJoin;
          nValues = nv === null || nv === void 0 ? void 0 : nv.map(function (vs) {
            return vs === null || vs === void 0 ? void 0 : vs.url;
          }).filter(function (vs) {
            return vs;
          }).join(s);
          oValues = ov === null || ov === void 0 ? void 0 : ov.map(function (vs) {
            return vs === null || vs === void 0 ? void 0 : vs.url;
          }).filter(function (vs) {
            return vs;
          }).join(s);
        }

        /* 防止 既不需要 toJSON 也不需要 toJoin */
        _this4.uploadValue = Array.isArray(nValues) ? (_nValues = nValues) === null || _nValues === void 0 ? void 0 : _nValues.join(typeof _this4.getJoin === 'string' ? _this4.getJoin : ',') : nValues;

        /* 只有 所有的状态都是 成功或者失败 的完成后的状态 才能触发 input 事件 */
        var nStatus = newValue.map(function (v) {
          return v.status;
        });
        if (!newValue.length && oldValue.length || nStatus.length && nStatus.every(function (v) {
          return !v || ['success', 'error'].includes(v);
        })) {
          _this4.$emit('input', nValues);
        }

        /* 触发输入框的获得焦点和失去焦点，用来触发校验 */
        _this4.$nextTick(function () {
          var _ref8;
          (_ref8 = ['input', 'textarea']) === null || _ref8 === void 0 || _ref8.forEach(function (str) {
            var _this4$$refs$wlUploa, _dom$querySelector, _dom$querySelector2;
            var dom = (_this4$$refs$wlUploa = _this4.$refs['wl-upload-input']) === null || _this4$$refs$wlUploa === void 0 ? void 0 : _this4$$refs$wlUploa.$el;
            dom === null || dom === void 0 || (_dom$querySelector = dom.querySelector(str)) === null || _dom$querySelector === void 0 || _dom$querySelector.focus();
            dom === null || dom === void 0 || (_dom$querySelector2 = dom.querySelector(str)) === null || _dom$querySelector2 === void 0 || _dom$querySelector2.blur();
          });
        });

        // 触发 change 事件
        _this4.$emit('change', nValues, oValues);
        _this4.uploadFilesOld = newValue.map(function (v) {
          return (0, _objectSpread2.default)({}, v);
        });
      }, {
        deep: true,
        immediate: true
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.defaultFiles.length = 0;
  }
};